import React from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "@/components/ui/table";
import {
    maintenanceCard,
    maintenanceHeading,
    maintenanceMutedText,
    maintenanceSectionTitle,
    maintenanceTableProps,
} from "./maintenanceTheme";

/**
 * Grid wrapper — matches Import Reports ReportDataGrid table shell.
 */
const MaintenanceDataGrid = ({
    title,
    recordCount,
    data,
    columns,
    emptyText = "No records found",
    Icon,
    isAplyingFilter,
    resetFilters,
    loading = false,
    getRowKey,
}) => {
    const { t } = useTranslation();
    const resolvedEmptyText = emptyText ?? t('maintenance.noRecordsFound');

    return (
        <div className={`${maintenanceCard} overflow-hidden transition-all duration-200`}>
            {title ? (
                <div className={maintenanceSectionTitle}>
                    <span className={`text-sm font-semibold ${maintenanceHeading}`}>{title}</span>
                    {recordCount != null && (
                        <span className={`text-xs ml-auto ${maintenanceMutedText}`}>
                            {recordCount} {recordCount === 1 ? t('maintenance.record') : t('maintenance.records')}
                        </span>
                    )}
                </div>
            ) : null}
            <div className="overflow-hidden">
                <DataTable
                    data={data}
                    columns={columns}
                    {...maintenanceTableProps}
                    loading={loading}
                    Icon={Icon}
                    emptyText={resolvedEmptyText}
                    isAplyingFilter={isAplyingFilter}
                    resetFilters={resetFilters}
                    getRowKey={getRowKey}
                />
            </div>
        </div>
    );
};

export default MaintenanceDataGrid;
